
 import { yupToFormErrors } from "formik";
 import * as Yup from "yup";
 
const TODIS_REJECT = {
    remarks: ""
};

 const REJECT = Yup.object().shape({
    //general section Rules:
    remarks: Yup.string("Remark is alphanumeric").required('Required'),
});

export { REJECT, TODIS_REJECT };